import React, { Component } from 'react';

import request from '../client/client';
import './index.css';
import FormCategory from '../form-category';

class FormStore extends Component {

  state = {
    criarLojaError: null,
    criarCategoriaError: null,
    novaCategoria: false,
    categories: [],
    category: ""
  }

  novaCategoriaTrue = () => {
    this.setState({
      novaCategoria: true
    })
  }

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value
    })
    console.log(e.target.name);
  }

  handleChangeCategory(e) {
    this.setState({
      description: e.target.value
    })
  }


  criarLoja = async (e) => {
    e.preventDefault();

    if(this.state.novaCategoria){
      try {
        const categoria = await request.post('/categories', {
          "description": this.state.description,
          "available": "true"
        })
        console.log(categoria);
        this.setState({
          "description": categoria.data._id
        })
      } catch (err) {
        this.setState({
          /* Adicionar tratamento de erro mais específico */
          criarCategoriaError: "Categoria não pode ser adicionada"
        })
      };
      this.setState({
        novaCategoria: false
      });
    }

    try {
      /*console.log({
        "name": this.state.storename,	
        "address": this.state.address,
        "cnpj": this.state.cnpj,
        "phone": this.state.phone,
        "category": this.state.description,
        "owner": localStorage.getItem('clientID')
      });*/
      const store = await request.post('/stores', {
        "name": this.state.storename,	
        "address": this.state.address,
        "cnpj": this.state.cnpj,
        "phone": this.state.phone,
        "category": this.state.description,
        "owner": localStorage.getItem('clientID')
      })
      console.log(store);
      await localStorage.setItem('storeID', store.data._id);
      this.props.history.replace('/criar-item');
    } catch (err) {
      console.log(err);
      this.setState({
        /* Adicionar tratamento de erro mais específico */
        criarLojaError: "Loja não pode ser adicionada"
      })
    };
  }

  async componentDidMount() {
    try {
      const categoriesRequest = await request.get('/categories');
      this.setState({
        categories: categoriesRequest.data
      })
      
    } catch (err) {
      /* ? */
    }
  }

  render() {
    return (
      <div className="text-center">
        <form onSubmit={this.criarLoja}>
          <input
            className="form-item"
            placeholder="Nome da Loja"
            name="storename"
            type="text"
            onChange={this.handleChange}
            value={this.state.storename}
          />
          <input
            className="form-item"
            placeholder="Endereço"
            name="address"
            type="text"
            onChange={this.handleChange}
            value={this.state.address}
          />
          <input
            className="form-item"
            placeholder="CNPJ"
            name="cnpj"
            type="text"
            onChange={this.handleChange}
            value={this.state.cnpj}
          />
          <input
            className="form-item"
            placeholder="Telefone"
            name="phone"
            type="text"
            onChange={this.handleChange}
            value={this.state.phone}
          />
          { !this.state.novaCategoria &&
            <select className="form-item" >
              <option selected disabled></option>  
              {this.state.categories.map(category => (
                <option onClick={this.handleChangeCategory.bind(this)} name="description" value={category._id} key={category._id}>{category.description}</option>  
              ))}
            </select>
          }
          <a className="nova-categoria" href="#" onClick={this.novaCategoriaTrue}>+ Nova Categoria</a>
          {
            !!this.state.novaCategoria &&
            /*<FormCategory onChange={this.handleChange.bind(this)} value={this.state.description} />*/
            <input
            className="form-item"
            placeholder="Nome da categoria"
            name="description"
            type="text"
            value={this.state.description}
            onChange={this.handleChangeCategory.bind(this)}

            />
          }
          {
            !!this.state.criarCategoriaError &&
            <div className="error-message">
              {this.state.criarCategoriaError}
            </div>
          }
          {
            !!this.state.criarLojaError &&
            <div className="error-message">
              {this.state.criarLojaError}
            </div>
          }
          <input
            className="form-submit"
            value="Enviar"
            type="submit"
          />
        </form>
      </div>
    )
  }
}

export default FormStore;



// WEBPACK FOOTER //
// ./src/components/form-store/index.js